import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../../../stylesheets/components/Reports/SubscriptionFees/SubscriptionFees.scss";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import { subscriptionFeesTabs } from "./Constantsubscription";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdModal from "@frameworks/web/components/generic/edModal";
import DownloadReportPopupDesk from "@frameworks/web/components/generic/DownloadReports/DownloadReportPopupDesk";
import PopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import SuccessPopup from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import PopupLoader from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import mainDI from "@frameworks/web/di/index";
import SubscriptionFeesMobile from "./SubscriptionFeesMobile";
import SubscriptionTabData from "./SubscriptionTabdata";
import di from "@frameworks/web/components/Reports/SubscriptionFees/di/servicelocator";
import { SubscriptionFeeSubType, } from "@domains/entities/interfaces/Reports/SubscriptionReport/ISubscriptionReport";
import { useDispatch, useSelector } from "react-redux";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import FamilyTaggingMain from "../FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
const SubscriptionFees = () => {
    var _a;
    const device = DeviceContext();
    const dispatch = useDispatch();
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const [selectedTab, setSelectedTab] = useState((_a = subscriptionFeesTabs[0]) === null || _a === void 0 ? void 0 : _a.eventKey);
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [operation, setOperation] = useState();
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const { reducersData: SubsFeedata, commonData: subsFeeCommData } = useSelector((state) => state.SubscriptionReport.SubscriptionFee);
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const disableDownload = () => {
        var _a, _b;
        return (subsFeeCommData.errorData.isOpen ||
            subsFeeCommData.loader ||
            subsFeeCommData.message.icon ===
                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.SUBSCRIPTION].icon ||
            (selectedTab === SubscriptionFeeSubType.RATE &&
                ((_a = SubsFeedata.subscriptionFee.rateBased) === null || _a === void 0 ? void 0 : _a.length) <= 0) ||
            (selectedTab === SubscriptionFeeSubType.VOLUME &&
                ((_b = SubsFeedata.subscriptionFee.volBased) === null || _b === void 0 ? void 0 : _b.length) <= 0));
    };
    React.useEffect(() => {
        if (device === null || device === void 0 ? void 0 : device.isDesktop)
            mainDI.header.RemoveHeaderData(true);
        else
            mainDI.header.RemoveHeaderData(false);
        dispatch(mainDI.footer.updateShowMob_Menu(false));
    }, [device]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollLimit = 150;
            if (openCalendar) {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                if (scrollY > scrollLimit) {
                    setOpenCalendar(false);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [openCalendar]);
    const paths = Array(3)
        .fill("")
        .map((_, idx) => React.createElement("span", { key: idx, className: `path${idx + 1}` }));
    const DownloadSubmitButtonText = () => {
        if ((downloadCheck && emailCheck) || (!downloadCheck && !emailCheck))
            return React.createElement(React.Fragment, null, "Download and Send Report");
        if (downloadCheck)
            return React.createElement(React.Fragment, null, "Download Report");
        if (emailCheck)
            return React.createElement(React.Fragment, null, "Send Report");
    };
    const loaderMessage = () => {
        if (downloadCheck && emailCheck)
            return "Download and Share";
        if (downloadCheck)
            return "download";
        if (emailCheck)
            return "share";
    };
    const modalTitleDwnldEmail = () => {
        if (downloadCheck && emailCheck)
            return "Downloading and Sharing Subscription";
        if (downloadCheck)
            return "Download Subscription";
        if (emailCheck)
            return "share Subscription";
    };
    const downloadSuccessNode = () => {
        if (downloadCheck && emailCheck)
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey" },
                "Your Subscription Report is successfully Downloaded and also Shared with",
                " ",
                React.createElement("span", { className: "txt-midnight-blue d-inline" }, di.subscriptionReport.emailList.length <= 3 ? (di.subscriptionReport.emailList.join()) : (React.createElement(React.Fragment, null,
                    di.subscriptionReport.emailList.slice(0, 2).join(", "),
                    ",",
                    React.createElement("br", null),
                    React.createElement("div", { className: "flexCenter" },
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor" }, di.subscriptionReport.emailList[2]),
                        "\u00A0",
                        React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", null,
                                "and \u00A0",
                                React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                    di.subscriptionReport.emailList.length - 3,
                                    " More",
                                    " ",
                                    di.subscriptionReport.emailList.length - 3 === 1
                                        ? "email"
                                        : "emails")), toolTipText: React.createElement(React.Fragment, null, di.subscriptionReport.emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "hover", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" })))))));
        if (downloadCheck)
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey" },
                "Your Subscription Report ",
                React.createElement("br", null),
                "is successfully downloaded"));
        if (emailCheck)
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" },
                "Your Subscription Report is ",
                React.createElement("br", null),
                "successfully shared with",
                " ",
                React.createElement("span", { className: "txt-midnight-blue d-inline" }, di.subscriptionReport.emailList.length <= 3 ? (di.subscriptionReport.emailList.join()) : (React.createElement(React.Fragment, null,
                    di.subscriptionReport.emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", { className: "" },
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                di.subscriptionReport.emailList.length - 3,
                                " More",
                                " ",
                                di.subscriptionReport.emailList.length - 3 === 1
                                    ? "email"
                                    : "emails")), toolTipText: React.createElement(React.Fragment, null, di.subscriptionReport.emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "hover", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))));
    };
    const FailureMessage = () => {
        if (downloadCheck && emailCheck)
            return "to download and share";
        if (downloadCheck)
            return "to download";
        if (emailCheck)
            return "to share";
    };
    const downloadEmailFile = (email, download) => {
        setShowLoader(true);
        setShowDownloadPopup(false);
        if (email)
            email.accodes = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
        if (download)
            download.accodes = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
        di.subscriptionReport
            .downloadAndSendSubsReport(email, download, selectedTab)
            .then((resp) => {
            if (resp) {
                setShowLoader(false);
                setDownloadSuccess(resp);
            }
            else {
                setDownloadFail(resp);
                setShowLoader(false);
            }
        })
            .catch((err) => {
            setDownloadFail(true);
            setShowLoader(false);
        });
    };
    const disableDownloadSubmit = (fromDate, toDate) => {
        return !(downloadCheck || emailCheck);
    };
    React.useEffect(() => {
        if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
            let payload = {
                accountId: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
                subType: selectedTab,
            };
            di.subscriptionReport.getSubscriptionFee(payload);
        }
    }, [selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, selectedTab]);
    return (React.createElement(GridContainer, { parentClass: "subscription-report-main-container px-0" }, device && device.isDesktop ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `container subs_container subscriptionReport new-reports-modalBackdrop common-reports-download-mail px-0 ${showLoader || downloadSuccess || downloadFail
                ? "modal-opacity-0"
                : ""}` },
            React.createElement(Row, { className: "Subscriptionicon" },
                React.createElement(Col
                // lg={6}
                , { 
                    // lg={6}
                    className: "mgt-30 d-flex align-items-center subscriptionfee justify-content-between" },
                    React.createElement("span", { className: "DMSansMedium_28_500 txt-midnight-blue" },
                        "Subscription ",
                        React.createElement("span", { className: "DMSan_28_400" }, "Fees")),
                    React.createElement("span", { className: "mk-card-topright d-flex align-items-center common-info-icon" }),
                    React.createElement(FamilyTaggingMain, { hideConsolidated: false }))),
            React.createElement(Row, { className: "position-relative" },
                React.createElement(GenericTabs, { defaultActiveKey: selectedTab, tabsArray: subscriptionFeesTabs.map((tab) => {
                        return {
                            title: tab.title,
                            eventKey: tab.eventKey,
                            tabContent: (React.createElement(SubscriptionTabData, { type: selectedTab, setShowDownloadPopup: setShowDownloadPopup, disableDownload: disableDownload })),
                        };
                    }), externalClassName: "subscription-subtabs subscriptionfeeborder common-tab-color px-0", callBackFunction: setSelectedTab })),
            device && device.isDesktop && (React.createElement(React.Fragment, null,
                React.createElement(EdModal, { show: showDownloadPopup, setShow: setShowDownloadPopup, size: "modal-md modal-dialog-centered", paths: paths, iconClass: "gap-8 icon-new-20", icon: "edel-icon-download-color-new", modalTitle: "modalDPTitle commonmodal gray-modal report-common-modal", title: "Download Subscription Report", showFooter: false, DisableOutsideClickClose: true },
                    React.createElement("div", { className: "downloadHoldingDesk taxreport" },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form" },
                                React.createElement(DownloadReportPopupDesk, { resetFields: showDownloadPopup, showLoader: showLoader, setShowLoader: setShowLoader, setDownloadSuccess: setDownloadSuccess, setDownloadFail: setDownloadFail, setOperation: setOperation, showdate: true, PDF_or_Excel: ReportType.PDF, submit: downloadEmailFile, submitBtnText: DownloadSubmitButtonText(), isAdditionalDeatils: true, reportType: undefined, setEmailCheck: setEmailCheck, setDownloadCheck: setDownloadCheck, customDisableSubmit: disableDownloadSubmit }))))))),
            showLoader && (React.createElement("div", { className: "modalBackground loader-red-common common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { message: `Your Subscription Report is getting prepared to <br /> ${loaderMessage()}`, Title: modalTitleDwnldEmail(), isDownloadIcon: true, goBack: () => setShowDownloadPopup(false) })))),
            downloadSuccess && (React.createElement("div", { className: "modalBackground common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: modalTitleDwnldEmail(), operation: operation, goBackText: true, messageReactNode: downloadSuccessNode(), sendBack: true, isDownloadIcon: true, goBack: () => setShowDownloadPopup(false) })))),
            downloadFail && (React.createElement("div", { className: "modalBackground common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: modalTitleDwnldEmail(), operation: operation, goBackText: true, sendBack: true, isDownloadIcon: true, message: `<span class='DMSans_16_500'>We ran into some technical  difficulties,<br> please try ${FailureMessage()} the report again!</span>`, goBack: () => setShowDownloadPopup(false) }))))))) : (React.createElement(SubscriptionFeesMobile, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, selectedTab: selectedTab, handleTabSelect: setSelectedTab, disableDownload: disableDownload, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode }))));
};
export default SubscriptionFees;
